// extracted by mini-css-extract-plugin
module.exports = {"itemSharing_wrapper":"styles_itemSharing_wrapper__a9Xtn","itemSharing_block":"styles_itemSharing_block__GPeiL"};